import createReactComponent from '../createReactComponent';
export default createReactComponent('move-vertical', 'MoveVertical', [["path",{"d":"m16 18-4 4-4-4m4 4V2m4 4-4-4-4 4","key":"svg-0"}]]);